import { useRef } from "react";

/**
 * 항상 최신 값을 가리키는 ref 를 반환한다.
 * 콜백을 effect 의존성에서 제외해 effect 가 안정적으로 1회만 실행되게 할 때 사용.
 */
export function useLatestRef<T>(value: T) {
  const ref = useRef(value);
  ref.current = value;
  return ref;
}
